<template>
  <div class="create-edit-pet-modal petit-nature-modal" id="printPetDetails">
    <div class="header is-print-hidden">
      <h1 class="subtitle is-4">Entregas efetuadas</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <div class="columns is-variable is-multiline print">
      <div class="column is-3 ">
        <figure class="image is-128x128 center-content">
          <img class="" src="../../assets/imgs/logo-petit-nature.jpg" alt="" />
        </figure>
      </div>
      <div class="column is-6 center-content title">
        <div>
          <h1 class="title has-text-centered">
            Relatório de entregas
          </h1>
        </div>
      </div>
      <div class="column is-3 center-content">
        <div class="label">
          {{ new Date() | moment("DD/MM/YYYY") }}
        </div>
      </div>
    </div>
    <div class="body section">
      <div class="columns is-variable is-multiline is-print-hidden">
        <div class="column is-12">
          <b-field label="Pet">
            <b-autocomplete
              expanded
              v-model="petSearchText"
              :data="petsList"
              placeholder="Buscar pet"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getPetAsyncData"
              @select="option => (selectedPet = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.name }}</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field label="Período">
            <b-datepicker
              v-model="dates"
              :date-formatter="formatter"
              icon="calendar-today"
              range
            >
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-12">
          <div class="buttons is-right">
            <a
              class="button is-primary"
              @click="generateReport()"
              :disabled="
                this.dates.length < 2 || (!selectedPet || !selectedPet.id)
              "
            >
              Gerar relatório
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-variable is-multiline"
        v-if="selectedPet && selectedPet.id"
      >
        <div class="column is-6">
          <span class="label">Dono</span>
          <span>{{ selectedPet.owner.name }}</span>
        </div>
        <div class="column is-6">
          <span class="label">Nome</span>
          <span>
            {{ selectedPet.name }}
          </span>
        </div>
        <div class="column is-6">
          <span class="label">Consumo</span>
          <span>{{ selectedPet.consumption }}g</span>
        </div>
        <div class="column is-6">
          <span class="label">Período</span>
          <span
            >{{ dates[0] | moment("DD/MM/YYYY") }} -
            {{ dates[1] | moment("DD/MM/YYYY") }}</span
          >
        </div>
        <div class="column is-12">
          <span class="label">Restrições</span>
          <div class="table-holder" v-if="selectedPet.ingredients.length">
            <table class="table">
              <thead>
                <tr>
                  <th>Ingredientes</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="restriction in selectedPet.ingredients"
                  :key="restriction.id"
                >
                  <td>{{ restriction.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="column is-12" v-else>
            <div class="no-items-message has-text-centered is-centered">
              Esse pet não possui restrições
            </div>
          </div>
        </div>
        <div class="column is-12" v-if="preparedData.length">
          <div class="columns is-variable is-multiline">
            <div class="column is-12">
              <h2 class="subtitle">Total ({{ preparedData.total }})</h2>
            </div>
            <div
              class="column is-6"
              v-for="data in preparedData"
              :key="data.id"
            >
              <span class="label">{{ data.receipt }} ({{ data.total }})</span>
              <div v-for="pack in data.packs" :key="pack.size">
                <span>{{ pack.quantity }} x {{ pack.size }}g</span>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12" v-if="petDeliveries.length">
          <label class="label">Entregas</label>
          <div class="table-holder">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Receita</th>
                  <th>Lote</th>
                  <th>Quantidade</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="delivery in petDeliveries" :key="delivery.id">
                  <td>{{ delivery.deliveryDate | moment("DD/MM/YYYY") }}</td>
                  <td>{{ delivery.receipt }}</td>
                  <td>{{ delivery.batch }}</td>
                  <td>{{ delivery.quantity }} x {{ delivery.packageSize }}g</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="column is-12" v-else>
          <div class="no-items-message has-text-centered is-centered">
            Esse pet não recebeu nenhuma entrega no período selecionado.
          </div>
        </div>
      </div>
    </div>
    <div class="footer has-text-right is-print-hidden"></div>
  </div>
</template>

<script>
import * as moment from "moment";
import utils from "@/helpers/debounce";
import QueryBuilder from "@/helpers/QueryBuilder";
import PetService from "@/services/PetService";
import * as XLSX from "xlsx";
import * as _saveAs from "file-saver";

export default {
  name: "PetDetailsByPeriodComponent",
  data: function() {
    return {
      petDeliveries: [],
      isLoading: true,
      dates: [new Date(), new Date()],
      isFetching: false,
      petSearchText: "",
      petsList: [],
      selectedPet: {},
      pet: {},
      preparedData: []
    };
  },
  methods: {
    getPetAsyncData: utils.debounce(function() {
      this.petsList = [];
      let query = {
        name: this.petSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      PetService.getPets(query)
        .then(({ data }) => {
          this.petsList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300),
    print() {
      this.$htmlToPaper("printPetDetails");
    },
    formatter(date) {
      let formattedDate = "";

      date.forEach(d => {
        if (formattedDate.length) {
          formattedDate += " - ";
        }
        formattedDate += moment(d).format("DD/MM/YYYY");
      });
      return formattedDate;
    },
    generateReport() {
      const format = "YYYY-MM-DD";
      const startDate = moment(this.dates[0]).format(format);
      const endDate = moment(this.dates[1]).format(format);
      PetService.getDeliveriesReportByPetIdAndPeriod(
        this.selectedPet.id,
        startDate,
        endDate
      )
        .then(data => {
          this.petDeliveries = data.data;
          this.prepareData(this.petDeliveries);
          this.isLoading = false;
          this.exportToXLS();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    exportToXLS() {
      let wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "Entregas de pet",
        Subject: "",
        Author: "Petit Nature",
        CreatedDate: new Date()
      };

      XLSX.utils.book_append_sheet(wb, this.getDeliveryListSheet(), "Entregas");
      XLSX.utils.book_append_sheet(wb, this.getReportSheet(), "Detalhes");

      let wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
      const fileName =
        "relatorio-entregas-pet-" +
        this.selectedPet.name +
        "-" +
        moment().format(`DD-MM-YYYY-mm-ss`);
      let buf = this.s2ab(wbout);
      _saveAs.saveAs(
        new Blob([buf], { type: "application/octet-stream" }),
        `${fileName}.xlsx`
      );
    },
    getReportSheet() {
      let ws_report_data = [["Período", this.formatter(this.dates)]];
      ws_report_data.push([]);
      this.preparedData.forEach(p => {
        let arr = [];
        arr.push(p.receipt);
        arr.push("Total");
        ws_report_data.push(arr);
        p.packs.forEach(pack => {
          ws_report_data.push([
            pack.quantity + " X " + pack.size + "g",
            pack.quantity
          ]);
        });
        ws_report_data.push(["", p.total]);
        ws_report_data.push([]);
      });
      return XLSX.utils.aoa_to_sheet(ws_report_data);
    },
    getDeliveryListSheet() {
      let ws_delivery_list_data = [
        [
          "Receita",
          "Data de entrega",
          "Lote",
          "Quantidade",
          "Pacote (g)",
          "Dono",
          "Pet",
          "Período"
        ]
      ];

      this.petDeliveries.forEach(p => {
        let arr = [];
        arr.push(p.receipt);
        arr.push(moment(p.deliveryDate).format("DD-MM-YYYY"));
        arr.push(p.batch);
        arr.push(p.quantity);
        arr.push(p.packageSize);
        arr.push(this.formatter(this.dates));

        ws_delivery_list_data.push(arr);
      });
      return XLSX.utils.aoa_to_sheet(ws_delivery_list_data);
    },
    s2ab(s) {
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf); //create uint8array as viewer
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    },
    prepareData(receipts) {
      const uniqueReceipts = new Set();
      receipts.forEach(r => uniqueReceipts.add(r.receipt));
      let receiptsNames = Array.from(uniqueReceipts);
      this.preparedData = [];
      receiptsNames.forEach(name => {
        const currentReceipt = receipts.filter(r => r.receipt === name);
        this.preparedData.push(this.getData(currentReceipt));
      });
      this.preparedData.total = this.getAllTotal(this.preparedData);
    },
    getAllTotal(data) {
      let total = 0;
      data.forEach(d => (total += d.total));
      return total;
    },
    getData: function(receipt) {
      const r = receipt[0].receipt;
      const time = new Date().getTime();
      const obj = {
        id: time + 1,
        receipt: r,
        products: this.getProducts(receipt),
        total: 0
      };
      obj.total = this.getTotal(obj.products);
      obj.packs = this.getTotalByPackSize(obj.products);

      return obj;
    },
    getProducts(receipt) {
      const products = [];

      receipt.forEach(r => {
        if (!this.checkBatchExists(r.batch, products)) {
          products.push({
            batch: r.batch,
            packs: [{ size: r.packageSize, quantity: r.quantity }]
          });
        } else {
          products.forEach(p => {
            if (p.batch === r.batch) {
              if (!p.packs.length) {
                p.packs = [{ size: r.packageSize, quantity: r.quantity }];
              } else {
                if (!p.packs.filter(p => p.size === r.packageSize).length) {
                  p.packs.push({ size: r.packageSize, quantity: r.quantity });
                } else {
                  p.packs.forEach(pack => {
                    if (pack.size === r.packageSize) {
                      pack.quantity += r.quantity;
                    }
                  });
                }
              }
            }
          });
        }
      });

      return products;
    },
    checkBatchExists(batch, products) {
      return products.filter(p => p.batch === batch).length > 0;
    },
    getTotal(products) {
      let total = 0;
      products.forEach(p => {
        p.packs.forEach(pack => (total += pack.quantity));
      });
      return total;
    },
    getTotalByPackSize(products) {
      let sizes = {};
      let obj = [];
      products.forEach(p => {
        p.packs.forEach(pack => {
          if (!sizes[pack.size]) {
            sizes[pack.size] = 0;
          }

          sizes[pack.size] += pack.quantity;
        });
      });
      Object.keys(sizes).forEach(k => {
        obj.push({ size: k, quantity: sizes[k] });
      });

      return obj;
    }
  },
  beforeMount() {
    // this.getPetDeliveries();
  }
};
</script>

<style scoped>
.table-holder {
  max-height: 350px;
  overflow: auto;
}
.print {
  display: none;
}
</style>
